export const TEXTS = {
  CHANGE_PRICE_PLAN_PERIOD_MODAL_GIFT: 'Месяц в подарок',
};
